
export const profiles = {
  title: 'Personality Profiles',
  subtitle: 'Discover the 19 unique personality profiles and understand how each type approaches work, communication, and collaboration.',
  exampleChart: 'Example Profile',
  patternCode: 'Pattern Code',
  seeAllProfiles: 'See All Profiles',
  backToAssessment: 'Take Assessment',
  averageScores: 'Average Scores',
  basedOnAssessments: 'Based on {{count}} assessments',
  exampleData: 'Example data',
  contributors: {
    title: 'Contributors ({{count}})',
    andMore: 'and {{count}} more...'
  }
};
